// Main styles
require('./css/colors.css');
require('./css/main.css');
require('./css/modules/icon.css');
require('./css/modules/list.css');
// require('./css/modules/login.css');
require('./css/modules/menu.css');
require('./css/modules/modal.css');
require('./css/modules/paginator.css');
require('./css/modules/popover.css');
require('./css/modules/form.css');
require('./css/custom.css');
require('./css/responsive.css');

require('./css/blocks_styles.css');
require('./css/footer.css');

//Headers
//require('./css/header/styles.css');

// Custom styles



// WEBPACK FOOTER //
// ./C:/wamp64/www/cig-landing/devel/css.js